"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigQueryTables = void 0;
var BigQueryTables;
(function (BigQueryTables) {
    BigQueryTables["AccountingDocuments"] = "fact_d365_accounting_documents";
    BigQueryTables["UnallocatedStock"] = "fact_d365_unallocated_stock";
})(BigQueryTables = exports.BigQueryTables || (exports.BigQueryTables = {}));
//# sourceMappingURL=big-query-tables.enum.js.map